/**
 * Created by lari on 09/06/2017.
 */
(function () {
  'use strict';
  
  /* @ngdoc object
   * @name examtemplate
   * @description
   *
   */
  angular
    .module('vcexamtemplate', [
      'ui.router',
      'ui.tree',
      'ui.bootstrap',
      'ngTagsInput',
      'vcfinance.privcat',
      'vctracker'
    ]);
}());
